<template>
    <div class="escalatorList">
        <div @click="selectCard(item.id)"
            :class='`card ${item.status == 1 ? "card_normal" : "card_abnormal"} ${selectedId === item.id ? "highlight" : ""}`'
            v-for="item in list" :key="item.id">
            <img v-if="item.status == 1" src="../../../assets/normal.svg" alt="" />
            <img v-else src="../../../assets/abnormal.svg" alt="" />
            <div class="card_text">
                <span :class='`text_top ${item.status == 1 ? "text_normal" : "text_abnormal"}`'>{{ item.remark }}</span>
                <span class="text_bottom">{{ item.status == 1 ? "正常运行" : "声纹异常" }}</span>
            </div>
        </div>
    </div>
</template>
    
<script>

export default {
    components: {

    },
    data() {
        return {
            list: [],
            selectedId: '',
        };
    },
    mounted() {
    },
    destroyed() {
    },
    computed: {
    },
    methods: {
        selectCard(id) {
            this.selectedId = id;
            this.$emit("selectGZ", id);
        }
    },
    watch: {
    },
};
</script>
    
<style lang="less" scoped>
.escalatorList {
    position: relative;
    width: calc(100% - 15px);
    height: calc(100% - 44px);
    display: flex;
    padding-left: 15px;
    flex-wrap: wrap;
    align-content: flex-start;
    overflow: auto;

    .highlight {
        border: 2px solid #44D7B6 !important;
    }

    .card {
        width: 46%;
        height: 89px;
        margin-right: 15px;
        border-radius: 2px;
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        cursor: pointer;

        img {
            width: 40px;
            height: 40px;
            margin: 0px 10px
        }

        .card_text {
            display: flex;
            flex-direction: column;
            width: calc(100% - 60px);

            .text_top {
                font-size: 18px;
                font-weight: 400;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .text_normal {
                color: #44D7B6;
            }

            .text_abnormal {
                color: #F7B500;
            }

            .text_bottom {
                font-size: 14px;
                font-weight: 400;
                color: #6D7278;
            }
        }
    }

    .card_normal {
        border: 1px solid rgba(148, 148, 148, 0.49);
    }

    .card_abnormal {
        border: 1px solid rgba(247, 181, 0, 0.46)
    }

    @media screen and (max-width: 1440px) {
        .text_top {
            font-size: 12px !important;
        }

        .text_bottom {
            font-size: 12px !important;
        }
    }
}
</style>
    
      


// WEBPACK FOOTER //
// src/pages/home/realTime/escalator-list.vue